import React, { useEffect, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  Alert, Box, Button, CircularProgress, Link, TextField, Typography,
} from '@mui/material';
import AuthLayout from '../components/AuthLayout';
import OtpInput from '../components/OtpInput';
import { useForgotPasswordViewModel } from '../viewmodels/AuthViewModels';

export default function ForgotPasswordView() {
  const vm = useForgotPasswordViewModel();
  const [loginId, setLoginId] = useState('');
  const [code, setCode] = useState('');
  const [password, setPassword] = useState('');

  useEffect(() => {
    document.title = 'Reset password · OrkaCrew';
  }, []);

  const submit = (e) => {
    e.preventDefault();
    if (vm.step === 'request') vm.requestCode(loginId);
    else vm.reset({ loginId, code, password });
  };

  if (vm.done) {
    return (
      <AuthLayout title="Password updated">
        <Alert severity="success" sx={{ mb: 2 }}>Your password was changed. You can sign in now.</Alert>
        <Button component={RouterLink} to="/signin" variant="contained" fullWidth size="large">Go to sign in</Button>
      </AuthLayout>
    );
  }

  return (
    <AuthLayout
      title="Reset your password"
      subtitle="We will send a code to your mobile or email."
      footer={<Link component={RouterLink} to="/signin">Back to sign in</Link>}
    >
      {vm.error && <Alert severity="error" sx={{ mb: 2 }}>{vm.error}</Alert>}
      <Box component="form" onSubmit={submit} noValidate>
        <TextField
          label="Mobile or email"
          value={loginId}
          onChange={(e) => setLoginId(e.target.value)}
          fullWidth
          margin="normal"
          disabled={vm.step === 'reset'}
          autoFocus
        />
        {vm.step === 'reset' && (
          <>
            <Typography variant="body2" color="text.secondary" align="center" sx={{ mt: 1 }}>Enter the code we sent</Typography>
            <OtpInput value={code} onChange={setCode} disabled={vm.busy} />
            <TextField
              label="New password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              fullWidth
              margin="dense"
              autoComplete="new-password"
              helperText="8+ characters with upper and lower case letters and a number"
            />
          </>
        )}
        <Button type="submit" variant="contained" fullWidth size="large" disabled={vm.busy} sx={{ mt: 2 }}>
          {vm.busy ? <CircularProgress size={22} color="inherit" /> : (vm.step === 'request' ? 'Send code' : 'Update password')}
        </Button>
      </Box>
    </AuthLayout>
  );
}
